<div class="chatbot-wrapper">
  <div class="bot-header">
    <div class="title-text">
      <div class="header-title">iChat</div>
      <div class="header-close cursor" (click)="botClose('close')">x</div>
    </div>
  </div>
  <div class="bot-content-wrapper" #scroll>
    <div *ngIf="masterChatList.length">
      <div *ngFor="let item of masterChatList;let i=index;">
        <div class="outgoing-msg" *ngIf="item.key==='outgoing'">
          <div class="sent-msg">
            <p>{{item.msg}}</p>
          </div>
        </div>
        <div class="incoming-msg flex-column" *ngIf="item.key==='incoming'">
          <div class=" recieved-msg">
            <pre *ngIf="item?.type==='json'">{{item.msg|json}}</pre>
            <p [innerHTML]="item.msg" *ngIf="item?.type!=='json'"></p>
          </div>
          <div *ngIf="i===(masterChatList.length-1) && chatCurrentResponse?.isJsonForm" class="d-flex">
            <div class="cursor recieved-msg-btn" (click)="botUserAction('cancel')">Cancel</div>
            <div class="recieved-msg-btn mrl-10 disable" (click)="botUserAction('reenter')">Reenter</div>
            <div *ngIf="chatCurrentResponse?.url" class="cursor recieved-msg-btn"
              (click)="botUserAction('proceed')">Proceed</div>
          </div>
        </div>
      </div>
      <div *ngIf="isLoader">
        <img src="../../assets/images/3dots-loading.gif" class="rocket" alt="">
      </div>
    </div>
    <div *ngIf="!masterChatList.length" class="no-msg">
      Say Hello...
    </div>
  </div>
  <div class="bot-chat-wrapper">
    <div class="input_msg_write align-items-center">
      <input type="text" class="h-35 w-100" id="user-input" matInput placeholder="Type here.." [formControl]="msg"
        (keyup.enter)="submitInput()">
      <div class="cursor" (click)="submitInput()">
        <img src="../../assets/images/rocketicon-chatboat.svg" class="rocket" alt="">
      </div>
    </div>
  </div>
</div>